import React from "react";
import { toHtml } from "./utils/exportUtils";

export default function SlatePreviewAndExport({value}) {

  // Convert Slate JSON to HTML
  const htmlPreview = toHtml(value);


  return (
    <div style={{ display: "flex", gap: "2rem" }}>
      {/* HTML Preview + Export */}
      <div style={{ flex: 1, border: "1px solid #ccc", padding: "1rem" }}>
        <h3>HTML Preview</h3>
        <div
          dangerouslySetInnerHTML={{ __html: htmlPreview }}
          style={{ minHeight: "200px" }}
        />
      </div>
    </div>
  );
}
